import { Controller } from "@hotwired/stimulus"
import { Shortcuts} from "shortcuts";

// Connects to data-controller="list-shortcuts"
export default class extends Controller {
  connect() {
    // share same shortcuts handler with global shortcuts, means handlers for single key shortcuts such as "j" won't
    // get triggered when that letter forms part of a 2 letter global shortcut sequence e.g. "g j"
    const shortcutsController =
        this.application.getControllerForElementAndIdentifier(document.body, "global-shortcuts");
    this.shortcuts = shortcutsController.shortcuts;
    console.log('list shortcuts controller connected️ using shared shortcuts handler');

    this.shortcuts.add([
      { shortcut: 'j', handler: () => this.listAction('next') },
      { shortcut: 'k', handler: () => this.listAction('previous') },
      { shortcut: 'o', handler: () => this.listAction('open') },
      { shortcut: 'Enter', handler: () => this.listAction('open') }
    ]);
  }

  disconnect() {
    this.shortcuts.remove({ shortcut: 'j' });
    this.shortcuts.remove({ shortcut: 'k' });
    this.shortcuts.remove({ shortcut: 'o' });
    this.shortcuts.remove({ shortcut: 'Enter' });
    console.log('shortcuts controller disconnected - removed list shortcuts');
  }

  listAction(action) {
    const listController =
        this.application.getControllerForElementAndIdentifier(document.getElementById("itemList"), "list");
    if (listController && listController[action]) {
      listController[action]();
    }
    return true;
  }

  initialize() {
    console.log('list shortcuts controller initialized');
  }
}
